"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SftpSettingsFilterDto = void 0;
const shared_1 = require("../shared");
const enums_1 = require("../../enums");
const class_validator_1 = require("class-validator");
const boolean_transform_1 = require("../../constants/boolean.transform");
const class_transformer_1 = require("class-transformer");
class SftpSettingsFilterDto extends shared_1.PaginationOptionsDto {
    constructor(sftpSettingsFilterOptions) {
        super();
        if (sftpSettingsFilterOptions && sftpSettingsFilterOptions.schoolId)
            this.schoolId = sftpSettingsFilterOptions.schoolId;
        if (sftpSettingsFilterOptions && sftpSettingsFilterOptions.schoolGroupId)
            this.schoolGroupId = sftpSettingsFilterOptions.schoolGroupId;
        if (sftpSettingsFilterOptions && sftpSettingsFilterOptions.groupLevel)
            this.groupLevel = sftpSettingsFilterOptions.groupLevel;
        if (sftpSettingsFilterOptions && sftpSettingsFilterOptions.importSubject)
            this.importSubject = sftpSettingsFilterOptions.importSubject;
        if (sftpSettingsFilterOptions && sftpSettingsFilterOptions.importFrequency)
            this.importFrequency = sftpSettingsFilterOptions.importFrequency;
        if (sftpSettingsFilterOptions && sftpSettingsFilterOptions.sftpAccountId)
            this.sftpAccountId = sftpSettingsFilterOptions.sftpAccountId;
    }
    schoolId;
    schoolGroupId;
    sftpAccountId;
    importSubject;
    importFrequency;
    groupLevel;
}
exports.SftpSettingsFilterDto = SftpSettingsFilterDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], SftpSettingsFilterDto.prototype, "schoolId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], SftpSettingsFilterDto.prototype, "schoolGroupId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], SftpSettingsFilterDto.prototype, "sftpAccountId", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(enums_1.ImportSubject),
    __metadata("design:type", String)
], SftpSettingsFilterDto.prototype, "importSubject", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(enums_1.ImportFrequency, { each: true }),
    __metadata("design:type", Array)
], SftpSettingsFilterDto.prototype, "importFrequency", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Transform)(boolean_transform_1.BooleanStringTransform),
    __metadata("design:type", Boolean)
], SftpSettingsFilterDto.prototype, "groupLevel", void 0);
